module.exports = __webpack_public_path__ + "img/challenges.e02371d9.png";